const Images = {
  IdeaImage: require("../../images/idea.svg"),
  Logo14: require("../../images/14-logo.svg"),
  AboutTopImage: require("../../images/about.svg"),
  V1: require("../../images/v-1.svg"),
  V2: require("../../images/v-2.svg"),
  V3: require("../../images/v-3.svg"),





  DevelopmentImage: require("../../images/development.svg"),
  Facebook: require("../../images/social/facebook.svg"),
  GitHub: require("../../images/social/github.svg"),
  Instragram: require("../../images/social/instragram.svg"),
  Linkedin: require("../../images/social/linkedin.svg"),

  YouTube: require("../../images/social/youtube.svg"),


  BNI: require("../../images/footer/bni.svg"),
  CII: require("../../images/footer/cii.svg"),
  KDL: require("../../images/footer/kdl.svg"),
  VS: require("../../images/footer/vs.svg"),
  DRMCA: require("../../images/footer/drmca.svg"),
  Pro: require("../../images/footer/pro.svg"),

  Blog1: require("../../images/blog/1.jpg"),
  Blog2: require("../../images/blog/2.jpg"),
  Blog3: require("../../images/blog/3.jpg"),


  S1: require("../../images/offers/1.png"),
  S2: require("../../images/offers/2.png"),
  S3: require("../../images/offers/3.png"),
  S4: require("../../images/offers/4.png"),




  SolutionsImage: require("../../images/solutions.png"),



};
export default Images;
